import { create } from 'zustand';

export interface Employee {
  id: number;
  position_id: number;
  position_title: number;
  sign_type: string;
  is_main: boolean;
  status: string;
  asan_cert_id: string;
  method: string;
  position: string;
}

export interface Company {
  id: number;
  parent_id: number;
  inn: string;
  customer_id: number;
  voen: string | null;
  status: string;
  title: string;
  title_en: string;
  title_ru: string;
  title_az: string;
  is_contract_enabled: boolean;
  is_digital_frame: boolean;
  ts_created: string;
  ts_changed: string;
  employee: Employee;
}

export interface User {
  id: number;
  asan_imza_id: string;
  phone: string;
  phone_plus: string;
  phone_otp: string;
  phone_otp_plus: string;
  lang: string;
  email: string;
  fin: string;
  is_totp: boolean;
  fname: string;
  lname: string;
  mname: string;
  fname_en: string;
  fname_ru: string;
  fname_az: string;
  lname_en: string;
  lname_ru: string;
  lname_az: string;
  mname_en: string;
  mname_ru: string;
  mname_az: string;
  status: string;
  ts_created: string;
  ts_changed: string;
  has_passcode: boolean;
  company: Company;
}

interface State {
  user: User | null;
}

interface Action {
  setUser: (user: User) => void;
}

const useAuth = create<State & Action>(set => ({
  user: null,
  setUser: user => set({ user }),
}));

export default useAuth;
